"use strict";
import "bootstrap/js/dist/scrollspy";

// Riff on components/regulus/catalogue_variants which works on list views
function showVariant(variantID, wrapper) {
    var variantFragmentPrefix = $('.js-product-variant-switcher').data('url-fragment-prefix');
    wrapper.find('.js-product-variants__variant').addClass('d-none')
        .filter(`[data-id="${variantID}"]`).removeClass('d-none');
}

$('select.js-variant-switcher').on('change', function(e){
    showVariant($(this).val(), $(this).closest('.js-product-card'));
});

$('a.js-variant-switcher, button.js-variant-switcher').on('click', function(e){
    e.preventDefault();
    $(this).addClass('active').siblings().removeClass('active');
    showVariant($(this).data('id'), $(this).closest('.js-product-card'));
});


$('body').scrollspy({ target: '#product-nav' });

function initProductNavScroll(){
    var productNav = $('#product-nav'),
        initialOffset = productNav.offset().top,
        w = $(window);

    var mobileScrollHandler = function() {
        if(w.width() < 992 && w.scrollTop() > initialOffset) {
            productNav.css("position", "fixed");
        }
        else {
            productNav.css("position", "static");
        }
    }


    if(w.width() < 992) {
        w.on('scroll', mobileScrollHandler);
    }
    else {
        productNav.css("position", "static");
    }
}


$(window).on('load resize', initProductNavScroll);
